import { cn } from "@/lib/utils";
import React from "react";
import { useCreateInternalChannel } from "@/components/pages/chats/hooks/useChannel";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MessageStaffButtonProps {
  userId: string | string[];
  className?: string;
}

export const MessageStaffButton = ({
  userId,
  className,
}: MessageStaffButtonProps) => {
  const navigate = useNavigate();
  const { mutateAsync } = useCreateInternalChannel();

  const handleMessageStaff = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      const channel = await mutateAsync({
        targetUserIds: Array.isArray(userId) ? userId : [userId],
        chat_type: "private",
      });
      navigate(`/internal-chats?activeChannel=${channel.id}`);
    } catch (error) {
      console.error("Failed to create internal channel", error);
    }
  };

  return (
    <Button
      variant="new_ghost"
      size="icon"
      className={cn("h-8 w-8", className)}
      onClick={handleMessageStaff}
    >
      <MessageSquare className="h-4 w-4" />
    </Button>
  );
};
